module.exports = __webpack_public_path__ + "static/biz-spec-f67631b2a3946dfc9228a9bf46fedd1d.jpg";